import { render } from "./EcommerceRibbon.vue?vue&type=template&id=571360ba"
import script from "./EcommerceRibbon.vue?vue&type=script&lang=js"
export * from "./EcommerceRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/notjusttravel/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__